
import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
  className?: string;
  icon?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  href,
  className = '',
  icon
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-montserrat font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer';
  
  const variantClasses = {
    primary: 'bg-gradient-to-r from-[#C8A45D] to-[#D4B76A] text-black hover:from-[#D4B76A] hover:to-[#E0C376] hover:shadow-lg hover:shadow-[#C8A45D]/30 hover:scale-105',
    secondary: 'bg-[#1C1C1C] text-white border border-[#C8A45D] hover:bg-[#C8A45D] hover:text-black hover:shadow-lg hover:shadow-[#C8A45D]/30',
    outline: 'border-2 border-[#C8A45D] text-[#C8A45D] hover:bg-[#C8A45D] hover:text-black hover:shadow-lg hover:shadow-[#C8A45D]/30'
  };
  
  const sizeClasses = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-xl'
  };
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;
  
  if (href) {
    return (
      <a href={href} className={classes}>
        {icon && <i className={`${icon} mr-2`}></i>}
        {children}
      </a>
    );
  }
  
  return (
    <button onClick={onClick} className={classes}>
      {icon && <i className={`${icon} mr-2`}></i>}
      {children}
    </button>
  );
};
